export function getLinkedInUrl(companyId: string): string {
    return `https://www.linkedin.com/company/${companyId}`
}
